import { Link } from "react-router-dom";
import { GraduationCap, ChevronRight, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { DynamicLearningTicker } from "@/components/DynamicLearningTicker";

export function AcademyBanner() {
  const { t } = useLanguage();

  return (
    <section className="py-10 md:py-16">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-amber-500/10 via-emerald-500/5 to-amber-500/10 border border-amber-400/30 p-6 md:p-10">
          <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full bg-amber-400/10 blur-[80px]" />
          <div className="absolute -bottom-20 -left-20 w-60 h-60 rounded-full bg-emerald-400/10 blur-[80px]" />

          <div className="relative flex flex-col md:flex-row items-center gap-6 md:gap-10">
            {/* Left: Split Globe + Rupee Icon */}
            <div className="shrink-0 h-20 w-20 md:h-24 md:w-24 rounded-2xl bg-gradient-to-br from-sky-400 to-emerald-500 flex items-center justify-center shadow-lg relative overflow-hidden">
              <Globe className="h-8 w-8 md:h-10 md:w-10 text-white/60 absolute left-2 top-3" />
              <span className="text-2xl md:text-3xl font-bold text-white absolute right-2 bottom-2">₹</span>
            </div>

            {/* Right: Content */}
            <div className="flex-1 text-center md:text-left">
              <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-500/15 text-amber-600 dark:text-amber-400 text-[10px] font-bold uppercase tracking-wider mb-3">
                🔥 {t("academy.bannerBadge")}
              </div>
              <h2 className="font-display text-xl md:text-2xl font-bold text-foreground mb-1 indic-text">
                {t("academy.bannerTitle")}
              </h2>
              <p className="text-sm font-semibold text-primary mb-2 indic-text">
                {t("academy.bannerSubtitle")}
              </p>
              <p className="text-sm text-muted-foreground mb-5 max-w-lg leading-relaxed indic-text">
                {t("academy.bannerHook")}
              </p>
              <Link to="/academy">
                <Button size="lg" className="gap-2 rounded-xl font-bold">
                  <GraduationCap className="h-4 w-4" />
                  {t("academy.bannerCta")}
                  <ChevronRight className="h-4 w-4" />
                </Button>
              </Link>
            </div>
          </div>

          {/* Social proof ticker */}
          <div className="relative mt-6 flex justify-center md:justify-start md:ml-[7.5rem]">
            <DynamicLearningTicker />
          </div>
        </div>
      </div>
    </section>
  );
}
